<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup" (addingAnother)="addingAnother($event)">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column formGroupName="sellableSizeGroup">
                        <wbo-size-group-single-select-edit-control [(ngModel)]="model.data.sellableSizeGroup.id" [allowClearSelectionOption]="false" formControlName="id"
                                                                   (valueChange)="onValueChange()"></wbo-size-group-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="externalName" [(ngModel)]="model.data.externalName"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="externalSizeName" [(ngModel)]="model.data.externalSizeName"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-edit-grid [data]="model.data.sellableSizeRelations" [editable]="true" [removable]="true" [entityPath]="'sellableSizeRelations'"
                               (saved)="sellableSizeRelationsSaved($event)" [reorderable]="true">
                    <wbo-sellable-edit-link-column field="sellable.name" componentPath="sellable"
                                                   [editMode]="EditMode.VIEW"></wbo-sellable-edit-link-column>
                    <wbo-column field="sellable.primaryCategory.name"></wbo-column>
                    <wbo-sellable-size-column [editable]="true" [sizeGroupIdField]="model.data.sellableSizeGroup.id || -1" field="sellableSize"></wbo-sellable-size-column>
                    <wbo-checkbox-column field="standardProduct" [editable]="true"></wbo-checkbox-column>
                    <wbo-edit-grid-add-row [identifierField]="'sellableId'" [componentPath]="'sellable'">
                        <wbo-edit-grid-add-row-quick-add>
                            <wbo-sellable-single-select-edit-control></wbo-sellable-single-select-edit-control>
                        </wbo-edit-grid-add-row-quick-add>
                        <wbo-edit-grid-add-row-actions>
                            <wbo-edit-grid-add-row-search [title]="'wbo.discount.edit.grid-add.products.addProductLines'"
                                                          [searchComponent]="ProductLineSearchPageComponent"></wbo-edit-grid-add-row-search>
                            <wbo-edit-grid-add-row-search [title]="'wbo.discount.edit.grid-add.products.addCompositeProducts'"
                                                          [searchComponent]="CompositeProductSearchPageComponent"></wbo-edit-grid-add-row-search>
                            <wbo-edit-grid-add-row-new-entity [title]="'wbo.discount.edit.grid-add.products.newProductLine'"
                                                              [editComponent]="ProductLineEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            <wbo-edit-grid-add-row-new-entity [title]="'wbo.discount.edit.grid-add.products.newCompositeProduct'"
                                                              [editComponent]="CompositeProductEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                        </wbo-edit-grid-add-row-actions>
                    </wbo-edit-grid-add-row>
                </wbo-edit-grid>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>



